import * as requestFromServer from './paypalRequestsCrud';
import {paypalRequestsSlice, callTypes} from './paypalRequestsSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';

export const getPaypalRequestsListIDPrefix = 'getPaypalRequestsList';
const {actions} = paypalRequestsSlice;

const getPaypalRequestsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getPaypalRequestsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getPaypalRequests(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalPaymentsCount, paymentsList, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount: totalPaymentsCount,
        pageCount: pageCount,
        entities: paymentsList,
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find paypal requests';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getPaypalRequests = getPaypalRequestsList(actions.paypalRequestsFetched);
export const getNextPaypalRequests = getPaypalRequestsList(actions.paypalRequestsAppended);

export const getPaypalRequestsListForExcelFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getPaypalRequestsForExcelFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data?.paymentsList ? data?.paymentsList : [];
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

